module.exports = __webpack_public_path__ + "static/media/hotel-business.996c223f.jpg";